import { Platform, useWindowDimensions } from 'react-native';

// Texto 12 B (Etapa 1 do modo computador): o mesmo app se adapta à largura da janela do navegador.
//   celular: menos de 600 px (como sempre) · tablet: 600 a 1023 px · computador: 1024 px ou mais.
// Só na versão web: no app instalado (celular e tablet) nada muda.
export type Tamanho = 'celular' | 'tablet' | 'computador';
export const tamanhoDe = (largura: number): Tamanho => (largura >= 1024 ? 'computador' : largura >= 600 ? 'tablet' : 'celular');

/** Largura máxima da coluna do app (o resto da janela fica na cor do tema). */
export const LARGURA_COLUNA: Record<Tamanho, number | undefined> = { celular: undefined, tablet: 760, computador: 900 };
/** Janela central dos formulários (criar/editar) no tablet e no computador. */
export const LARGURA_JANELA = 560;
/** Largura confortável de leitura (páginas, anotações): o texto não vai de ponta a ponta. */
export const LARGURA_LEITURA = 760;

export function useTamanho(): Tamanho {
  const { width } = useWindowDimensions();
  return Platform.OS === 'web' ? tamanhoDe(width) : 'celular';
}
/** Quantas colunas cabem para cartões com pelo menos "minimo" px de largura (sempre 1 no celular). */
export function useColunas(minimo = 300): number {
  const { width } = useWindowDimensions();
  const tam = useTamanho();
  if (tam === 'celular') return 1;
  const util = Math.min(width, LARGURA_COLUNA[tam] ?? width) - 32;
  return Math.max(1, Math.min(3, Math.floor(util / minimo)));
}

/** Largura de cada cartão numa grade de n colunas com o espaço "gap" entre eles (só no navegador). */
export const larguraColuna = (n: number, gap: number) => ({ width: `calc(${100 / n}% - ${Math.ceil((gap * (n - 1)) / n)}px)` as unknown as number });
